// Scorecards from a specific golf course

import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import {
    FETCH_GOLF_SCORECARDS_SUMMARY,
    FETCH_GOLF_SCORECARDS_SUMMARY_SUCCESS,
    FETCH_GOLF_SCORECARDS_SUMMARY_FAIL,
    FETCH_GOLF_SCORECARD_DETAIL,
    FETCH_GOLF_SCORECARD_DETAIL_FETCHING,
    FETCH_GOLF_SCORECARD_DETAIL_SUCCESS,
    FETCH_GOLF_SCORECARD_DETAIL_FAIL,
    FETCH_GOLF_SCORECARD,
    FETCH_GOLF_SCORECARD_FETCHING,
    FETCH_GOLF_SCORECARD_SUCCESS,
    FETCH_GOLF_SCORECARD_FAIL,
    UPDATE_GOLF_SCORECARD,
    UPDATE_GOLF_SCORECARD_UPDATING,
    UPDATE_GOLF_SCORECARD_SUCCESS,
    UPDATE_GOLF_SCORECARD_FAIL,
    DELETE_GOLF_SCORECARD,
    DELETE_GOLF_SCORECARD_DELETING,
    DELETE_GOLF_SCORECARD_SUCCESS,
    DELETE_GOLF_SCORECARD_FAIL
} from '../actions/golfScorecardActions.js';

import { FETCH_GOLF_COURSE_SUCCESS } from '../actions/golfCourseActions.js';

export function* fetchGolfScorecardsSummarySaga(action) {
    try {
        const queryString = toQueryString({
            ...(action.connectionDisplayName && { connectionDisplayName: action.connectionDisplayName }),
            'user-locale': action.userLocale,
            'per-page': 10000
        });

        const url = `/gcs-golfcommunity/api/v2/scorecard/summary${queryString}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_SCORECARDS_SUMMARY_SUCCESS,
            connectionDisplayName: action.connectionDisplayName,
            displayName: action.displayName,
            scorecardSummaries: response.data.scorecardSummaries || []
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_SCORECARDS_SUMMARY_FAIL,
            scorecardSummaries: []
        });
    }
}

export function* fetchGolfScorecardSaga(action) {
    try {
        yield put({
            type: FETCH_GOLF_SCORECARD_FETCHING
        });

        const url = `/gcs-golfcommunity/api/v2/scorecard/${action.scorecardId}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_SCORECARD_SUCCESS,
            scorecard: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_SCORECARD_FAIL,
            status: e.response?.status
        });
    }
}

export function* updateGolfScorecardSaga(action) {
    try {
        yield put({
            type: UPDATE_GOLF_SCORECARD_UPDATING
        });

        const url = `/gcs-golfcommunity/api/v2/scorecard/${action.scorecardId}`;

        const patches = action.patches;

        const config = {
            headers: {
                'json-response-body': false,
                'Content-Type': 'application/json-patch+json'
            }
        };

        const response = yield call(golfApi.patch, url, patches, config);

        yield put({
            type: UPDATE_GOLF_SCORECARD_SUCCESS
            // scorecard: response.data
        });
    } catch (e) {
        yield put({
            type: UPDATE_GOLF_SCORECARD_FAIL
            // scorecard: {}
        });
    }
}

export function* deleteGolfScorecardSaga(action) {
    try {
        yield put({
            type: DELETE_GOLF_SCORECARD_DELETING
        });

        const url = `/gcs-golfcommunity/api/v2/scorecard/${action.scorecardId}`;

        const response = yield call(golfApi.delete, url);

        yield put({
            type: DELETE_GOLF_SCORECARD_SUCCESS,
            scorecardId: action.scorecardId
        });
    } catch (e) {
        yield put({
            type: DELETE_GOLF_SCORECARD_FAIL
        });
    }
}

export function* fetchGolfScorecardDetailSaga(action) {
    try {
        yield put({
            type: FETCH_GOLF_SCORECARD_DETAIL_FETCHING
        });

        const queryString = toQueryString({
            'scorecard-ids': action.scorecardId,
            'include-next-previous-ids': true,
            'user-locale': action.locale,
            'include-longest-shot-distance': true
        });

        const url = `/gcs-golfcommunity/api/v2/scorecard/detail${queryString}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_SCORECARD_DETAIL_SUCCESS,
            scorecardId: action.scorecardId,
            scorecardDetail: response.data.scorecardDetails?.length ? response.data.scorecardDetails[0] : {}
        });

        if (response.data.courseSnapshots?.length) {
            yield put({
                type: FETCH_GOLF_COURSE_SUCCESS,
                golfCourse: response.data.courseSnapshots[0]
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_GOLF_SCORECARD_DETAIL_FAIL
        });
    }
}

export const golfScorecardSummary = [
    takeEvery(FETCH_GOLF_SCORECARDS_SUMMARY, fetchGolfScorecardsSummarySaga),
    takeEvery(FETCH_GOLF_SCORECARD_DETAIL, fetchGolfScorecardDetailSaga),
    takeEvery(FETCH_GOLF_SCORECARD, fetchGolfScorecardSaga),
    takeEvery(UPDATE_GOLF_SCORECARD, updateGolfScorecardSaga),
    takeEvery(DELETE_GOLF_SCORECARD, deleteGolfScorecardSaga)
];
